import React, {useState, useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
    HeaderToolbar,
    Loading,
    ErrorScreen,
    UserProfile,
    ServicesCard,
    RecentCalls,
    RecentPurchases,
    BalanceCard,
    AccountBanner,
    EndpointCard
} from "../../components";
import { useStore }from "../../store";
import {useAuthUser} from "../../components/auth-provider";
import {AccountService, CallsService, EndpointService, InvoiceService} from '../../services'
import {setAccount, setEndpoint} from "../../store/actions";
import purchases from "../../utils/purchases";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height : '100%',
        width  : '100%',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    content: {
        flexGrow: 1,
        paddingTop: theme.spacing(2),
        // [theme.breakpoints.up('sm')]: {
        //     marginRight: drawerWidth,
        // },
    },
}));

const HomePage = (props) => {
    const classes = useStyles();
    const [state, setState] = useState({
        isPending : true,
        isError   : false,
        isSuccess : false,
        error     : {},
        calls     : [],
        purchases : [],
        showBalance : true,
    });
    const {user} = useAuthUser();           // Get the logged in user
    const [store, dispatch] = useStore();   // Get the global store

    // Scroll to top on mount
    useEffect( () => {
        document.getElementById('psb').scrollTo(0,0);
    }, [])  // <- empty deps means it runs only on load

    // Get the user's account data on mount
    useEffect(() => {
        let unloaded = false;   // Set a flag in case we're unloaded before the API call returns

        Promise.all([
            AccountService.get(user.accountId),
            CallsService.getForAccount(user.accountId, 0, 5),
            InvoiceService.search(user.accountId, 0, 5),
            EndpointService.getForAccount(user.accountId)
        ]).then((results) => {
            // results contains [account, callsResult, invoiceResult, endpointResult]
            if (!unloaded) {
                const account = results[0];
                const endpoint = results[3];

                // account.status = -1;
                // account.closed = '2020-07-07T00:00:00Z'
                // account.type=''
                // account.trialExpiry = '2020-07-06T00:00:00Z'
                // account.services[0].active = 0;
                // account.balance = -2500;

                // Only display the balance card for an open, prepaid account
                // const showBalance = (account.type === 'pre-paid' && (account.status === 1 ||
                //     (account.status === 0 && typeof(account.closed) !== 'undefined') ))
                const showBalance = (account.type === 'pre-paid' && account.balance < 0)

                // Set the local state
                setState({
                    isPending: false,
                    isError:false,
                    isSuccess: true,
                    error: {},
                    calls: results[1].calls,
                    purchases: purchases(results[2].invoices),
                    showBalance: showBalance,
                })

                // Set the global state
                dispatch(setAccount(account))
                dispatch(setEndpoint(endpoint))
            }
        })
            .catch((error) => {
                //console.log('HomePage: error:', error);
                if (!unloaded) {
                    setState({
                        isPending: false,
                        isError: true,
                        isSuccess: false,
                        error,
                        calls: null,
                        invoices: null,
                        showBalance: false,
                    })
                }
            })

        // If you return a function from a useEffect hook, React runs it to clean up.
        return () => { unloaded = true }

    }, [user.accountId, dispatch])


    return (
        <div className={classes.root}>
            <AppBar position="fixed" className={classes.appBar}>
                <HeaderToolbar location={props.location.pathname}/>
            </AppBar>

            { state.isPending && <Loading/> }

            { state.isError && <ErrorScreen error={state.error}/> }

            { state.isSuccess &&
            <React.Fragment>

                {/*<Hidden xsDown>*/}
                {/*    <TableOfContents links={tocLinks} containerId="psb" />*/}
                {/*</Hidden>*/}

                <main className={classes.content}>
                    <Toolbar />

                    <div className="flex flex-grow flex-col">

                        <div className="mb-2">
                            <UserProfile user={store.user}
                                         variant="home"
                                         animation="transition.expandIn"
                                         delay={200}
                            />
                        </div>

                        {/* Display applicable account banners */}
                        <AccountBanner account={store.account} variant="suspended" animation="transition.expandIn" delay={250}/>
                        <AccountBanner account={store.account} variant="reactivate" animation="transition.expandIn" delay={250} />
                        {/*<AccountBanner account={store.account} variant="pendingClosed" animation="transition.expandIn" delay={250} />*/}
                        {/*<AccountBanner account={store.account} variant="upgrade" animation="transition.expandIn" delay={250} />*/}

                        { state.showBalance ?
                            <div className="my-2">
                                <BalanceCard account={store.account}
                                             animation="transition.expandIn"
                                             delay={300}
                                />
                            </div>
                            :
                            null
                        }

                        <div className="my-2">
                            <ServicesCard account={store.account}
                                          animation="transition.expandIn"
                                          delay={400}
                            />
                        </div>

                        {store.endpoint.id ?
                            <div className="my-2">
                                <EndpointCard endpoint={store.endpoint}
                                              animation="transition.expandIn"
                                              delay={400}
                                />
                            </div>
                            :
                            null
                        }

                        <div className="my-2">
                            <RecentCalls
                                calls={state.calls}
                                animation="transition.expandIn"
                                delay={500}
                            />
                        </div>

                        <div className="my-2">
                            <RecentPurchases
                                purchases={state.purchases}
                                animation="transition.expandIn"
                                delay={600}
                            />
                        </div>
                    </div>

                </main>
            </React.Fragment>
            }
        </div>
    );
}

export default HomePage;